const DEFAULT_YOUNGEST_AGE = 15
export const UNDER_YOUNGEST_AGE = DEFAULT_YOUNGEST_AGE - 1

export const MINIMUM_DATE = new Date('1900-01-01')
